import React from 'react';
import './DialogSettings.css';

import RadioButton from '../RadioButton/RadioButton';
import { getLocale } from '../../locales/getLocale';
import { plainRetrieve } from '../../utils/safeStoring';

import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
import SlSwitch from '@shoelace-style/shoelace/dist/react/switch';


function DialogSettings ({ isOpen, setIsOpen, onChangeAppTheme, onChangeDyslexiaFont }) {

    const appTheme = plainRetrieve('appTheme') || 'system';
    const useDyslexiaFont = (plainRetrieve('fontFamily') === 'open-dyslexic') || false;
    
  return (
    <SlDialog 
        label={getLocale('SettingsDialog.title')}
        open={isOpen} 
        onSlRequestClose={() => setIsOpen(false)}
        style={{ 'color': 'var(--on-surface)' }}
    >

        <div className="settings-dialog-body">

            <div className="settings-dialog-apptheme">
                {getLocale('SettingsDialog.optionTheme')}

                <RadioButton 
                    initActiveValue={appTheme} 
                    onChangeActiveValue={onChangeAppTheme} 
                />
            </div>

            <div className="settings-dialog-row">
                {getLocale('SettingsDialog.optionDyslexia')}
                <SlSwitch checked={useDyslexiaFont} onSlChange={(e) => onChangeDyslexiaFont(e.target.checked)} />
            </div>

            <small className='ask-support' style={{ margin: '0' }}>
                {getLocale('SignUp.askSupport')}<br/>
                <a href={`mailto:${getLocale('SignUp.supportMail')}`}>{getLocale('SignUp.supportMail')}</a>
            </small>
        
        </div>
    
    </SlDialog>
  );
};


export default DialogSettings;
